import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

export interface MenuOption {
	title: string;
	action?: string;
	icon?: string;
	disabled?: boolean;
}

@Component({
	standalone: true,
	selector: 'app-bubble-button',
	templateUrl: './bubble-button.component.html',
	styleUrls: ['./bubble-button.component.scss'],
	imports: [ MatIconModule, CommonModule, MatTooltipModule ],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BubbleButtonComponent {
	@ViewChild('optionsWrapper', { read: ElementRef }) options_wrapper!: ElementRef;
	@Output() action: EventEmitter<string> = new EventEmitter<string>();
	@Input() base_options!: Array<MenuOption>;
	opened: boolean = false;

	options: Array<MenuOption> = [];

	toggleButton() {
		this.opened = !this.opened;

		if (!this.opened)
			this.removeOptions();
		else
			this.addOptions();
	}

	addOptions() {

		let i = 0;
		const id = setInterval(() => {
			this.options.push(this.base_options[i]);
			i++;

			if (this.base_options.length === i) clearInterval(id);
		}, 50);
	}

	removeOptions() {
		const elements = this.options_wrapper.nativeElement.children as Array<HTMLElement>;

		let i = elements.length - 1;
		const id = setInterval(() => {

			elements[i].style.opacity = '0';
			elements[i].style.scale = '0.7';

			if (i === 0) {
				clearInterval(id);

				setTimeout(() => { this.options = [] }, 200);
			}

			i--;
		}, 50);
	}

	selectOption(item: MenuOption) {
		if (item.disabled) return;

		this.action.emit(item.action);

		this.toggleButton();
	}
}
